import { createSubsetSelector } from 'webui/utils/selectors';
export const legacy_custom_controls_config = createSubsetSelector([
    'id',
    'custom_controls',
    'custom_controls_state',
    'custom_controls_elements__loading',
    'custom_controls_elements__fail',
    'custom_controls_elements__fail_message',
]);
export const legacy_custom_controls_state = createSubsetSelector([
    'custom_controls',
    'custom_controls_state',
    'custom_controls_elements__loading',
    'custom_controls_elements__fail',
]);
